import {Pricing} from "./product";



export type HitSourceProduct = {
    bundle: any | null;
    company_id: string;
    company_id_sku: string;
    id: string;
    name: string;
    options: any | null;
    pricing: Pricing | null;
    product_id: string;
    quantity: number;
    sku: string;
    two_d_image_url: string;
    upc: string;
    variant_name: string;
};


type OrderDetailsProduct = {
    id: string
    name: string
    variant_name: string
    upc: string
    sku: string
    product_id: string
}

type HitSourceOrderDetailSection = {
    name: string;
    row_images: any[]; // Specify the type instead of any if the structure is known
};

type HitSourceOrderDetail = {
    id: string;
    sku: string;
    quantity: number;
    quantity_done: number;
    quantity_failed: number;
    upc: string;
    neatolabs_cost: number;
    status: string;
    sections: HitSourceOrderDetailSection[];
    created_at: string;
    last_change_at: string;
    product: OrderDetailsProduct;
    lumialase_job_call_status: string;
};

export type HitSourceOrder = {
    id: string;
    company_id: string;
    order_number: string;
    external_order_number: string;
    order_status: string;
    profanity_check_status: string;
    lumialase_job_call_status: string;
    order_date: string;
    order_details: HitSourceOrderDetail[];
    created_at: string;
    order_created_at: string;
    order_last_changed_at: string;
    event_time: string;
};

export type Hit = {
    _index: HitSourceIndex;
    _id: string;
    _source: HitSourceProduct | HitSourceOrder // Union type since _source can be either a product or an order
};

export enum HitSourceIndex {
    PRODUCT_V1 = 'product_v_1',
    PRODUCT_V2 = 'product_v_2',
    ORDER_V1 = 'order_v_1'
}

type Hits = {
    total: {
        value: number;
    };
    hits: Hit[];
};

export type SearchResult = {
    hits: Hits;
};

export function isHitSourceProduct(hitSource: HitSourceProduct | HitSourceOrder): hitSource is HitSourceProduct {
    return (hitSource as HitSourceProduct).sku !== undefined;
}